import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Download, Users, CheckCircle, ArrowRight } from "lucide-react";

const EmailCapture = () => {
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [showScrollCapture, setShowScrollCapture] = useState(false);
  const [email, setEmail] = useState("");
  const [exitEmail, setExitEmail] = useState("");
  const [hasShownExitIntent, setHasShownExitIntent] = useState(false);
  const [hasShownScrollCapture, setHasShownScrollCapture] = useState(false);

  // Exit intent detection
  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !hasShownExitIntent) {
        setShowExitIntent(true);
        setHasShownExitIntent(true);
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, [hasShownExitIntent]);

  // Scroll trigger detection (70% of page)
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercentage > 70 && !hasShownScrollCapture) {
        setShowScrollCapture(true);
        setHasShownScrollCapture(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasShownScrollCapture]);

  const handleExitEmailSubmit = (e) => {
    e.preventDefault();
    if (exitEmail) {
      // Here you would typically send to your email service
      console.log("Exit intent email:", exitEmail);
      setShowExitIntent(false);
      // Show success message or redirect
    }
  };

  const handleScrollEmailSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Here you would typically send to your email service
      console.log("Scroll capture email:", email);
      setShowScrollCapture(false);
      // Show success message or redirect
    }
  };

  return (
    <>
      {/* Exit Intent Popup */}
      {/* <AnimatePresence>
        {showExitIntent && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowExitIntent(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-white rounded-2xl p-8 max-w-md w-full relative shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowExitIntent(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>

              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Download className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Wait! Get Your FREE Hiring Guide
                </h3>
                
                <p className="text-gray-600 mb-6">
                  Before you go, grab our exclusive "5 Personality Red Flags That Cost You $60K Per Bad Hire" guide - used by 260+ HR leaders.
                </p>

                <form onSubmit={handleExitEmailSubmit} className="space-y-4">
                  <input
                    type="email"
                    value={exitEmail}
                    onChange={(e) => setExitEmail(e.target.value)}
                    placeholder="Enter your work email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                    required
                  />
                  
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white font-bold py-3 rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all flex items-center justify-center gap-2"
                  >
                    Download Free Guide <ArrowRight className="w-5 h-5" />
                  </button>
                </form>

                <div className="mt-4 flex items-center justify-center gap-4 text-sm text-gray-500">
                  <span className="flex items-center gap-1">
                    <CheckCircle className="w-4 h-4 text-green-500" />
                    No spam
                  </span>
                  <span className="flex items-center gap-1">
                    <CheckCircle className="w-4 h-4 text-green-500" />
                    Instant download
                  </span>
                </div>

                <p className="text-xs text-gray-400 mt-4">
                  Join 2,260+ HR professionals getting weekly hiring insights
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}

      {/* Scroll-Triggered Inline Capture */}
      {/* <AnimatePresence>
        {showScrollCapture && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            className="fixed bottom-48 md:bottom-10 left-4 right-4 md:left-auto md:right-8 md:w-96 z-40"
          >
            <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-6 relative">
              <button
                onClick={() => setShowScrollCapture(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-100 to-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-purple-600" />
                </div>
                
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 mb-2">
                    Get Weekly Hiring Tips
                  </h4>
                  <p className="text-sm text-gray-600 mb-4">
                    Join 2,260+ leaders getting insider strategies to avoid bad hires
                  </p>

                  <form onSubmit={handleScrollEmailSubmit} className="space-y-3">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Your work email"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                      required
                    />
                    
                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white font-medium py-2 rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all text-sm"
                    >
                      Get Free Tips
                    </button>
                  </form>

                  <p className="text-xs text-gray-400 mt-2">
                    No spam • Unsubscribe anytime
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence> */}
    </>
  );
};

export default EmailCapture; 